/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { computed } from 'vue';
import { useStore } from 'vuex';
import { FLEET_ROLE, ROLE_NAME } from '@hems/util/src/constant/role';
export const useRole = () => {
    const store = useStore();
    /**  roleName은 로그인 후에 항상 존재하는 값으로 타입 오류 방지를 위해 not null assertion 처리함 */
    const roleName = computed(() => store.state.user.roleNm);
    /**  roleCode는 로그인 후에 항상 존재하는 값으로 타입 오류 방지를 위해 not null assertion 처리함 */
    const roleCode = computed(() => store.state.user.roleCd);
    const isInstaller = roleName.value === ROLE_NAME.INSTALLER;
    const isUser = roleName.value === ROLE_NAME.USER;
    const isAdminGroup = !isInstaller && !isUser;
    const isAdmin = roleName.value === ROLE_NAME.ADMIN;
    const isDev = roleName.value === ROLE_NAME.DEV;
    const isService = roleName.value === ROLE_NAME.SERVICE;
    const isDevOrAdmin = isDev || isAdmin;
    const isDevOrAdminOrService = isDevOrAdmin || isService;
    const fleetRole = computed(() => store.state.user.fleetRole);
    const isFleetViewer = fleetRole.value === FLEET_ROLE.FLEET_VIEWER;
    return {
        roleName,
        roleCode,
        isInstaller,
        isUser,
        isAdminGroup,
        isAdmin,
        isDev,
        isService,
        isDevOrAdmin,
        isDevOrAdminOrService,
        isFleetViewer,
    };
};
